export interface MediaAsset {
  id: string;
  file_name: string;
  file_path: string;
  file_url: string;
  file_size: number;
  mime_type: string;
  width: number | null;
  height: number | null;
  alt_text: string | null;
  tags: string[] | null;
  folder: string | null;
  created_at: string;
  source?: string | null;
  source_url?: string | null;
  attribution?: string | null;
  language?: string | null;
  usage_count?: number | null;
  selected?: boolean;
}

export const CATEGORIES = [
  "uncategorized",
  "tech-ai",
  "cyber-security",
  "programming",
  "economy-trade",
  "corporate-brands",
  "entrepreneurship",
  "cyber-physical",
  "politics-world",
  "science",
  "sports",
  "lifestyle-society",
  "space-aero",
  "brand-logos",
  "icons",
  "backgrounds",
  "product-photos",
  "logos",
  "illustrations",
  "screenshots",
  "banners",
] as const;

export type MediaCategory = (typeof CATEGORIES)[number];

export const CATEGORY_LABELS: Record<string, string> = {
  uncategorized: "Non classé",
  "tech-ai": "Tech & IA",
  "cyber-security": "Cybersécurité",
  programming: "Programmation",
  "economy-trade": "Économie & Commerce",
  "corporate-brands": "Corporate & Marques",
  entrepreneurship: "Entrepreneuriat",
  "cyber-physical": "Systèmes Cyber-Physiques",
  "politics-world": "Politique & Monde",
  science: "Science",
  sports: "Sports",
  "lifestyle-society": "Lifestyle & Société",
  "space-aero": "Espace & Aéro",
  "brand-logos": "Logos de Marques",
  icons: "Icônes",
  backgrounds: "Arrière-plans",
  "product-photos": "Photos produit",
  logos: "Logos",
  illustrations: "Illustrations",
  screenshots: "Captures d'écran",
  banners: "Bannières",
};

export function formatSize(bytes: number) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function getImageDimensions(file: File): Promise<{ width: number; height: number }> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
      URL.revokeObjectURL(img.src);
    };
    img.onerror = () => resolve({ width: 0, height: 0 });
    img.src = URL.createObjectURL(file);
  });
}
